// extracted by mini-css-extract-plugin
export var lowPriority = "Shell-module--lowPriority--7a0c0";
export var underOverlay = "Shell-module--underOverlay--033a4";